import { Header, Page, Toolbox } from 'redesign';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DocumentsTableProvider } from './table/documents-table';
import { DocumentPageToolbox } from './documents-page-toolbox';
import { DOCUMENTS_INITIAL_VALUES, DocumentsParams } from './documents-type';
import { useExternalParams } from '../../../../../shared/hooks';

export const DocumentsPage = () => {
  const { t } = useTranslation('hq-screen-specific');
  const [params, setParams] = useExternalParams(DOCUMENTS_INITIAL_VALUES);

  return (
    <Page
      header={<Header titleText={t('document_check.page_title')} />}
      toolbox={
        <Toolbox alignCenter={true}>
          <DocumentPageToolbox params={params as DocumentsParams} setParams={setParams} />
        </Toolbox>
      }
    >
      <Box width="100%">
        <DocumentsTableProvider params={params as DocumentsParams} setParams={setParams} />
      </Box>
    </Page>
  );
};
